import { useBreakpointValue } from '@chakra-ui/react'

import FormInner from '../FormInner/FormInner'

type WidthoutFormTagProps<T> = {
  onClose: (data?: T) => unknown
  children: React.ReactNode
  onSubmit?: (data?: T) => unknown
  submitLabel?: string
}

function WithoutFormTag<T>({
  children,
  onClose,
  submitLabel,
  onSubmit,
}: WidthoutFormTagProps<T>) {
  const modalSize = useBreakpointValue({ sm: 'full', md: 'md' })
  if (modalSize === undefined) return null
  return (
    <FormInner
      onClose={onClose}
      isLoading={false}
      submitLabel={submitLabel}
      onSubmit={onSubmit || onClose}
    >
      {children}
    </FormInner>
  )
}

export default WithoutFormTag
